// src/plugins/vuetify.js
import 'vuetify/styles'
import { createVuetify } from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'
import { aliases, mdi } from 'vuetify/iconsets/mdi'
import '@mdi/font/css/materialdesignicons.css'

export default createVuetify({
  components,
  directives,
  icons: {
    defaultSet: 'mdi',
    aliases,
    sets: { mdi }
  },
  theme: {
    defaultTheme: 'light',
    themes: {
      light: {
        colors: {
          primary: '#0D1F2B',
          secondary: '#1A454A',
          accent: '#052947',
          error: '#b71c1c',
          info: '#4C7489',
          warning: '#E98459',
          achor: '#152B35',
          tertiary: '#074D56'
        }
      }
    }
  }
})
